// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"958":"6f7d5acd","2281":"7321d99b","2574":"5a3c82f5","2686":"26d59c48"}[chunkId] + ".chunk.css";
};